import CommonItems from "components/common-item/CommonItems";
import Loader from "components/Loader";
import MainContentLeft from "components/main-components/MainContentLeft";
import PageLoader from "components/page-components/PageLoader";
import Pagination from "components/Pagination";
import EmptyBlockInventoryCraft from "components/placeholder-blocks/EmptyBlockInventoryCraft";
import { useOutletContext } from "react-router-dom";
import emptyImg from "assets/img/icons/empty-predictions.svg";
import emptyIcon from "assets/img/icons/craft-prediction.svg";

const Predictions = () => {
  const {
    items,
    filters,
    isFiltersLoading,
    isItemsLoading,
    offsetCount,
    setOffsetCount,
    paginationData,
    getOpenedClass,
  } = useOutletContext();

  if (!items.length && isFiltersLoading === true) {
    return <PageLoader />;
  }

  return (
    <main className="main-content">
      <MainContentLeft
        getOpenedClass={getOpenedClass}
        filters={filters}
        setOffsetCount={setOffsetCount}
      />
      <div className="main-content__right">
        {isItemsLoading && !items.length ? (
          <Loader />
        ) : items.length ? (
          <>
            <CommonItems items={items} />
            <Pagination
              offsetCount={offsetCount}
              setOffsetCount={setOffsetCount}
              paginationData={paginationData}
            />
          </>
        ) : (
          <EmptyBlockInventoryCraft
            img={emptyImg}
            icon={emptyIcon}
            path="/crafting/prediction"
            text="No Prediction Cards"
          />
        )}
      </div>
    </main>
  );
};

export default Predictions;
